
import GridContent from "./GridContent";

function PopUp({ children, onOpen, onClose, open }) {

  return (
    <div className="popup-overlay" >
      <div className="popup" style={{zIndex: '100' }} onClick={(e) => e.stopPropagation()}>
        {/*<GalleryComp/>*/}
        <GridContent/>
      </div>
    </div>
  );
}

export default PopUp;
